module.exports = __webpack_public_path__ + "img/chilo-infuscatellus.eac92d69.jpg";